/*
 * Bow Trade-in guard.
 *
 * The "Bow Trade-in Box" product page shows cascading Manufacturer / Model /
 * Hand dropdowns that look up an approved bow list. Historically the Add to
 * Cart button was never actually gated on a successful match, so a customer
 * could submit the trade-in request before finishing the dropdowns (or if
 * the approved-list lookup failed to load), and an unapproved/unlisted bow
 * could slip through with junk or blank data attached to the order.
 *
 * This script is loaded on every page (it's a harmless no-op anywhere the
 * #bow-lookup widget isn't present) and adds a hard requirement: the Add to
 * Cart button stays disabled until Manufacturer, Model, and Hand have all
 * been selected AND matched against the approved list, and a capture-phase
 * submit listener on document blocks the actual form submission outright if
 * that isn't the case -- this works regardless of script load order versus
 * the theme's own product-form handling, because capture-phase listeners on
 * document always run before an element's own submit handlers.
 */
(function () {
  function init() {
    var wrapper = document.getElementById('bow-lookup');
    if (!wrapper) return; // Not on the trade-in page -- nothing to do.

    var form = wrapper.closest('form');
    if (!form) return;

    var submitButton = form.querySelector('[type="submit"]');
    var hiddenVal = document.getElementById('usedValueField');
    var manufacturerField = document.getElementById('manufacturerField');
    var modelField = document.getElementById('modelField');
    var handField = document.getElementById('handField');
    var errorDiv = document.getElementById('bowLookupError');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.id = 'bowLookupError';
      errorDiv.setAttribute('role', 'alert');
      errorDiv.style.display = 'none';
      errorDiv.style.color = '#b00020';
      errorDiv.style.fontSize = '0.95em';
      errorDiv.style.marginTop = '8px';
      wrapper.appendChild(errorDiv);
    }

    function hasValidSelection() {
      return !!(
        hiddenVal && hiddenVal.value &&
        manufacturerField && manufacturerField.value &&
        modelField && modelField.value &&
        handField && handField.value
      );
    }

    function showError(message) {
      if (!errorDiv) return;
      errorDiv.textContent = message || '';
      errorDiv.style.display = message ? 'block' : 'none';
    }

    function syncButtonState() {
      if (!submitButton) return;
      var valid = hasValidSelection();
      submitButton.disabled = !valid;
      submitButton.setAttribute('aria-disabled', (!valid).toString());
      submitButton.classList.toggle('disabled', !valid);
      submitButton.style.opacity = valid ? '' : '0.5';
      submitButton.style.cursor = valid ? '' : 'not-allowed';
      if (valid) showError('');
    }

    // Fail closed immediately -- nothing is submittable until a match is
    // confirmed, even before the sheet data has finished loading.
    syncButtonState();

    // The page's own inline script updates the hidden fields directly on
    // "change" events fired by #brand / #model / #hand (listeners attached
    // straight to those elements). Those target-phase listeners always run
    // before the event bubbles up here to document, so by the time this
    // delegated handler runs the hidden fields already reflect the latest
    // selection.
    document.addEventListener('change', function (event) {
      var id = event.target && event.target.id;
      if (id === 'brand' || id === 'model' || id === 'hand') {
        syncButtonState();
      }
    });

    // Hard backstop: block the actual add-to-cart submission if the bow
    // hasn't been matched against the approved list. Registered on document
    // with capture:true, so it fires during the capture phase -- guaranteed
    // to run before the submit event reaches the form and any bubble-phase
    // handlers on it (including the theme's own product-form add-to-cart
    // handler), regardless of which script registered its listener first.
    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;
        if (!hasValidSelection()) {
          event.preventDefault();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          showError(
            "Please select your bow's manufacturer, model, and hand from the lists above before submitting. If your bow isn't listed, it isn't eligible for mail-in trade-in yet -- please contact us."
          );
          if (errorDiv && errorDiv.scrollIntoView) {
            errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
